import FeedbackForm from '@/views/FeedbackForm.vue';

const routes = [{ path: '/*', name: 'Home', component: FeedbackForm }];

export { routes };

export default routes;
